import React from "react";

const ColorModeContext = React.createContext({
  toggleColorMode: () => { },
  setPrimaryColorLight: (_) => { },
  setPrimaryColorDark: (_) => { },
  setAppLogoLight: (_) => { },
  setAppLogoDark: (_) => { },
  setAppLogoFavicon: (_) => { },
  setAppLogoBackgroundLight: (_) => { },
  setAppLogoBackgroundDark: (_) => { },
  setAppLogoBackground: (_) => { },
  setAppLogoHorizontalMenu: (_) => { },
  setAppLogoHorizontalMenuDark: (_) => { },
  setAppLogoSplash: (_) => { },
  appLogoHorizontalMenu: null,
  appLogoHorizontalMenuDark: null,
  appLogoSplash: null,
  appLogoBackground: null,
});

export default ColorModeContext;
